<template lang="pug">
div.content.background
  .row.body-login
    .col-md-12.body-login-mobile
      div.lg-img.text-center
        a(href="/")
          img(src="../../assets/Obee_Logo_140@2x.png" width='280px' height='120px')
      .card.lg-body
        .card-content.lg-custom-card-content
          div.col-md-6.type-login(@click="signInSocial('facebook')")
            div.pull-left
              img(src="../../assets/images/login/ic_fb.svg" style='width:50px;')
            div.custom-btn-fb Tiếp tục với Facebook
          div.col-md-6.type-login(@click="signInSocial('google')")
            div.pull-left
              img(src="../../assets/images/login/ic_google.svg" style='width:50px;')
            span.custom-btn-gg Tiếp tục với Google
          .clearfix
          div.col-md-12
            div.line-strike
              span hoặc
          div.col-md-12
            .alert.alert-danger(v-if='error') {{error}}
            //- p.lg-alert-danger(v-if='error') * {{error}} *
          div.form-group.row(style="margin:0;")
            div.col-md-12
              input#username.form-control(type="text" name="username" placeholder="Tên đăng nhập" required autofocus v-model="username" @blur="checkUsername" autocomplete="off")
              //- md-fg-input(v-model='username' :labelFloating='false', type='text' :required='true', placeholder='Tên đăng nhập')
          div.form-group.row(style="margin:0;")
            div.col-md-12
              //- input#password.form-control(type="password" name="password" placeholder="Mật khẩu" required autocomplete="off" v-model="password")
              //- md-fg-input(v-model='password' :labelFloating='false', type='password' :required='true', placeholder='Mật khẩu')
              .form-group.custom-form-group(style='position:relative;margin-top:10px;')
                input#password.form-control(v-model="password" :type='passwordType' placeholder="Mật khẩu" required style='padding-right: 40px !important;' v-on:keyup="validateEmailAddress")
                i.material-icons.lg-icon-password(@click="switchVisibility" v-if="passwordType === 'text'") visibility
                i.material-icons.lg-icon-password(@click="switchVisibility" v-else) visibility_off
          div.form-group.row.mb-0.text-center(style='margin-top: 2px;')
            div.col-md-12
              button.btn.lg-btn-save(@click='submitFormLogin') Đăng nhập
            div.col-md-12
              div.pull-left
                span.lg-forgot-password(@click="onForgotPassword") Quên mật khẩu?
              br(v-if="$isMobile()")
              div.lg-reg-pull-right
                span Chưa có tài khoản,
                span.lg-reg-now(@click="onRegister" style='font-weight: bold;')  Đăng ký ngay!
</template>

<script>
import firebase from 'firebase'
import gql from 'graphql-tag'
import RegisterModal from './RegisterModal'
import ForgotPasswordModal from './ForgotPassword'
import store from '../../store'
import graphql from '../Model/graphql'
import $ from 'jquery'
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {
    MdNotification
  },
  data() {
    return {
      email: '',
      username: '',
      password: '',
      error: null,
      socialType: null,
      countEmail: 0,
      passwordType: 'password',
      front_params: null
      // time: null
    }
  },
  apollo: {
    email: {
      query: gql(graphql.GET_USER_PUBLIC),
      fetchPolicy: 'no-cache',
      variables() {
        return { username: this.username }
      },
      update: data => {
        // console.log(data)
        if (data.v_user_public.length === 0) {
          return null
        } else {
          return data.v_user_public[0].email
        }
      },
      skip() {
        return this.username == null
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  created () {
    if (this.$route.params.front_top !== undefined) {
      this.front_params = this.$route.params
    }
    if (this.$route.params.register_reload) {
      this.showNotification('Đăng ký thành công! Vui lòng xác thực Email trước khi đăng nhập.', 'success', 'top', 'right', 5000)
      // this.$router.go(0)
    }
    store.commit('setIsHomePage', false)
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        canCancel: false
      })
    },
    async checkEmailExist(email) {
      // debugger
      if (email) {
        await this.$apollo.query({
          query: gql(graphql.COUNT_EMAIL_ACCOUNT),
          fetchPolicy: 'no-cache',
          variables: {
            email: email
          }
        }).then((res) => {
          if (res) {
            // debugger
            this.countEmail = res.data.v_user_public_aggregate.aggregate.count
          }
        })
      }
    },
    signInSocial(type) {
      switch (type) {
        case 'google':
          this.$store.dispatch('signInGoogleAction')
          .then(async (result) => {
            // show loading
            this.show()
            // kiem tra email ton tai
            await this.checkEmailExist(result.user.email)
            if (this.countEmail === 0) {
              this.loader.hide()
              this.onRegister(null, result.user.email, result.user.displayName, result.additionalUserInfo.profile.picture)
              // debugger
            } else {
              // debugger
              this.loader.hide()
              store.commit('setIsLoggedIn', true)
              if (this.front_params && this.front_params.name !== null) {
                store.commit('setIsHomePage', true)
                this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
              } else {
                this.$router.push('account')
              }
            }
          })
          .catch((error) => {
            if (error.code === 'auth/popup-closed-by-user') {
              this.error = ''
            } else if (error.code === 'auth/cancelled-popup-request') {
              this.error = ''
            } else if (error.code === 'auth/network-request-failed') {
              this.error = 'Đã xảy ra lỗi mạng (như thời gian chờ, kết nối bị gián đoạn hoặc máy chủ không thể truy cập được).'
            } else {
              console.error(error)
              this.loader.hide()
              this.error = error
            }
          })
          break
        case 'facebook':
          this.$store.dispatch('signInFacebookAction')
          .then((result) => {
            store.commit('setIsLoggedIn', true)
            if (this.front_params && this.front_params.name !== null) {
              store.commit('setIsHomePage', true)
              this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
            } else this.$router.push('account')
          })
          .catch((error) => {
            if (error.code === 'auth/operation-not-allowed') {
              this.error = 'Chưa cấu hình xác thực Provider Facebook.'
            } else if (error.code === 'auth/popup-closed-by-user') {
              this.error = ''
            } else if (error.code === 'auth/cancelled-popup-request') {
              this.error = ''
            } else if (error.code === 'auth/network-request-failed') {
              this.error = 'Đã xảy ra lỗi mạng (như thời gian chờ, kết nối bị gián đoạn hoặc máy chủ không thể truy cập được).'
            } else {
              console.error(error)
              this.error = error
            }
          })
          break
      }
    },
    onRegister(e, email, fullname, picture) {
      // console.log(email, fullname)
      try {
        this.$modal.show(RegisterModal, {
          newEmail: email,
          newFullName: fullname,
          newPicture: picture,
          selectedTeacher: false,
          selectedStudent: false
        }, {
          // width: '43%',
          height: 'auto',
          classes: ['col-6'],
          adaptive: true,
          resize: true,
          clickToClose: false
        })
      } catch (e) {
        console.error(e)
      }
    },
    checkUsername() {
      if (this.username != null) {
        this.$apollo.queries.email.refresh()
      }
    },
    onForgotPassword() {
      this.$modal.show(ForgotPasswordModal, {
        selectedTeacher: false,
        selectedStudent: false
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        resize: true,
        clickToClose: false
      })
    },
    validateEmailAddress(e) {
      if (e.keyCode === 13) this.submitFormLogin()
      else if (e.keyCode === 27) this.password = ''
    },
    submitFormLogin() {
      if (this.email == null) {
        this.error = 'Tài khoản không tìm thấy'
      } else {
        const user = {
          email: this.email,
          password: this.password
        }
        this.$store.dispatch('signInAction', user).then((status, msg) => {
          var fbUser = firebase.auth().currentUser
          if (fbUser.emailVerified) {
            this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_USER_VERIFY),
              variables: {uid: this.$store.getters.user}
            })
            store.commit('setIsLoggedIn', true)
            if (this.front_params && this.front_params.name !== null) {
              store.commit('setIsHomePage', true)
              this.$delete(this.front_params, 'name')
              this.front_params = Object.assign(this.front_params, {name: 'Account'})
              this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
            } else {
              this.$router.push('/account')
            }
          } else {
            this.error = 'Email chưa được xác thực.'
            // this.$store.dispatch('signOutAction')
          }
        }).catch((error) => {
          // console.log(error)
          if (error.code === 'auth/wrong-password') {
            this.error = 'Mật khẩu không hợp lệ.'
          } else if (error.code === 'auth/user-not-found') {
            this.error = 'Tài khoản không tìm thấy'
          } else {
            this.error = error
          }
        })
      }
    }
  }
}
if (window.innerWidth < 991) {
  $(document).on('focus', 'input#password', function() {
    document.querySelector('input#password').scrollIntoView()
  })
}
</script>

<style lang="scss">
:root {
  --color-lg-fb: #3B5998;
  --color-lg-gg: #DA4837;
  --color-lg-yellow: #FFD311;
}
.content {
  &.background {background: #FBF4D2 url('../../assets/images/login/bg_pattern.png') no-repeat center 150px; min-height: 100%;}
}
.body-login {
  width: 584px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin: 0 auto;
  padding-top: 30px;
  .lg-img {
    background: transparent;
    margin-bottom: 10px;
  }
  .lg-body {
    margin-top: 0;
    width: 584px;
    height: auto;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 10px;
    opacity: 1;
    padding-top: 31px;
    .lg-custom-card-content {
      padding-top: 0;
      padding-left: 10px;
      padding-right: 10px;
      border-radius: 10px;
      .line-strike{
        width: 100%; 
        text-align: center; 
        border-bottom: 1px solid #B4B4B4; 
        line-height: 0.1em;
        margin: 30px 0px;
        span {
          background:#fff; 
          padding:0 10px;
          color: #B4B4B4;
          font-family: 'adobe-clean', sans-serif;
        }
      }
      .lg-alert-danger {
        color: red;
      }
      
      .custom-btn-fb {
        background-color: var(--color-lg-fb);
        color: white;
        font-size: 15px;
        font-family: 'adobe-clean', sans-serif;
        // font-weight: bold;
        text-align: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: block;
        width: 190x;
        height: 50px;
        margin-left: 50px;
        padding-top: 15px;
        cursor: pointer;
      }
      .custom-btn-gg {
        background-color: var(--color-lg-gg);
        color: white;
        font-size: 15px;
        // font-weight: bold;
        font-family: 'adobe-clean', sans-serif;
        text-align: center;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: block;
        width: 190x;
        height: 50px;
        margin-left: 50px;
        padding-top: 15px;
        cursor: pointer;
      }
      .lg-icon-password {
        margin-top: -43px; 
        display:block;
        position:absolute;
        right:10px;
        padding:auto 5px;
        &:hover {
          cursor: pointer;
        }
      }
      .lg-btn-save {
        background: var(--color-lg-yellow);
        color:black;
        text-transform: none;
        font-size: 14px;
        font-family: 'adobe-clean', sans-serif;
        border: 1px solid #FFD311;
        border-radius: 5px;
        // box-shadow: 0px 0px 0px;
        margin-top: 0px !important;
        width: 100%;
      }
      .lg-reg-pull-right {
        float: right;
      }
      .lg-forgot-password {
        font-family: 'adobe-clean', sans-serif;
        &:hover {
          cursor: pointer;
        }
      }
      .lg-reg-now {
        font-family: 'adobe-clean', sans-serif;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .body-login {
    .body-login-mobile{
      padding: 0;
      .lg-body {
        height: auto;
        background: transparent;
        box-shadow: none;
        padding-top: 15px;
        .card-content{margin: 0 15px; background: #fff; padding-top: 15px !important;
          .type-login{margin-bottom: 10px;}
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .body-login {
    width: 100%;
    .body-login-mobile{
      padding: 0;
      .lg-body {
        width: 100%;
        height: auto;
        background: transparent;
        box-shadow: none;
        padding-top: 15px;
        .card-content{margin: 0 15px; background: #fff; padding-top: 15px !important;
          .type-login{margin-bottom: 10px;}
        }
      }
    }
  }
}

// cellphones
@media (max-width: 414px) {
  .body-login {
    width: 100%;
    .body-login-mobile{
      padding: 0;
      .lg-body {
        width: 100%;
        height: auto;
        background: transparent;
        box-shadow: none;
        padding-top: 15px;
        .card-content{margin: 0 15px; background: #fff; padding-top: 15px !important;}
        .lg-custom-card-content {
          padding-left: 5px;
          padding-right: 5px;
          .type-login {
            &:nth-child(2n) {margin-bottom: 0;}
          }
          .custom-btn-gg {
            margin-top: 5px;
          }
          .lg-reg-pull-right {
            float: left;
          }
          .line-strike {
            width: 50%;
            margin: 30px auto 30px auto;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?cd478bda